import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { Router } from '@angular/router';
import { NAVBAR_OFFERS_ROUTE_NAME, NavItemModel } from '@libs/shared/models';
import { MobileNavigationComponent } from '../../navigation';

@Component({
  selector: 'ui-offers',
  imports: [
    MobileNavigationComponent,
  ],
  templateUrl: './offers.component.html',
  styleUrl: './offers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OffersComponent {
  public currentCategoryId: InputSignal<string | undefined> = input();

  public constructor(private readonly router: Router) {
  }

  public async onCategoryChange(navItem: NavItemModel): Promise<void> {
    await this.router.navigateByUrl(`/${NAVBAR_OFFERS_ROUTE_NAME}/${navItem?.id ?? ''}`);
  }
}
